export const ADD_AND_SAVE_BANNER = 'add-and-save-banner'
export const BRIGHTBACK_PROMO_BANNER = 'brightback-promo-banner'
export const DOWNLOAD_APP_BANNER = 'download-app-banner'
export const PROMO_BANNER = 'active-promo-banner'
export const REFERRAL_BANNER = 'referral-banner'
